import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { BehaviorSubject } from "rxjs";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { AppService } from "../../../app/services/app.service";
import { ApiserviceService } from "../../httpservice/apiservice.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  version_string: any;
  version_api: any;
  version_system: any;
  user: String = "";
  is_dropdown: boolean;
  checkuserLoc = false;
  datauser = [];
  datausers = [];

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  public appPages = [
    {
      title: "Tax Invoice",
      titleTH: "ใบกำกับภาษี",
      url: "/tax-invoice",
      icon: "../../../assets/icons/tax.png",
      isActive: false,
      action: 1,
    },

    {
      title: "Replace",
      titleTH: "ใบทดแทน",
      url: "/replace",
      icon: "../../../assets/icons/replace.png",
      isActive: false,
      action: 2,
    },
    {
      title: "Credit Note",
      titleTH: "ใบลดหนี้",
      url: "/credit-note",
      icon: "../../../assets/icons/creditnote.png",
      isActive: false,
      action: 3,
    },
    {
      title: "No Tax ID",
      titleTH: "ใบกำกับภาษีกรณีไม่มี Tax ID",
      url: "/no-tax-invoice",
      icon: "../../../assets/icons/tax.png",
      isActive: false,
      action: 4,
    },
    {
      title: "Report",
      titleTH: "รายงาน",
      url: "/report",
      icon: "../../../assets/icons/report.png",
      isActive: false,
      action: 5,
    },
    {
      title: "Resend/Print",
      titleTH: "ส่ง Mail ซ้ำ/พิมพ์ ",
      url: "/resend",
      icon: "../../../assets/icons/resend.png",
      isActive: false,
      action: 6,
    },
    {
      title: "Inquiry Data",
      titleTH: "สอบถามข้อมูล",
      url: "/inquiry",
      icon: "../../../assets/icons/inquiry.png",
      isActive: false,
      action: 7,
    },
    {
      title: "Config",
      titleTH: "กำหนดค่า",
      url: "/customer-search",
      icon: "../../../assets/icons/settings.png",
      isActive: false,
      action: 8,
    },
  ];

  constructor(
    public appService: AppService,
    public router: Router,
    public alertController: AlertController,
    public app: AppService,
    public apiservice: ApiserviceService,
    public loadingController: LoadingController,
    public storage: Storage
  ) {}

  ngOnInit() {}

  async ionViewDidEnter() {
    console.log("router===: ", this.router);
    this.version_string = this.appService.versionString;
    this.version_api = this.appService.versionAPI;
    this.version_system = this.appService.versionBE;
    this.appPages = this.appService.mappingRoleManagement(this.appPages);
    this.user = _getStorage(STORAGE.userID).toUpperCase();
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    if (
      this.userRole === "ETAXSUPERADMIN" ||
      this.userRole === "SUPERADMIN" ||
      this.userRole === "ADMINEDIT" ||
      this.userRole === "ADMINCONFIG"
    ) {
      this.is_dropdown = false;
    } else {
      this.is_dropdown = true;
    }

    let bu: any = {};
    if (this.userRole === "ETAXSUPERADMIN" || this.userRole === "SUPERADMIN") {
      bu = { bu: "all" };
    } else {
      bu = { bu: this.userBu };
    }
    const bodyEncrypt = await this.apiservice.encryptBody(bu);
    const bodyReq = await this.apiservice.setBase64(bodyEncrypt);

    this.apiservice
      ._get(
        this.apiservice.apiUrl +
          this.apiservice.getListLocation +
          `api=${bodyReq}`
      )
      .then(async (res: any) => {
        console.log("res======: ", res);
        if (res.statusCode === 200) {
          this.datauser = res.data.location;
          this.datausers = res.data.location;
          let userLoc = this.datauser.filter(
            (i) => i.seller_storeid === this.userLoc
          );
          this.userLoc = userLoc[0];
          console.log("this.userLoc=====:: ",this.userLoc)
          _setStorage(STORAGE.SOURCE_SYSTEM, userLoc[0].source_system);
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      })
      .catch((error) => {
        this.appPages = this.appPages.map((m) => ({ ...m, isActive: false }));
      });
  }
  searchstoreid(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.datauser = this.datausers.filter((item) => {
        return (
          item.seller_storeid.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.seller_branch_name.toLowerCase().indexOf(val.toLowerCase()) >
            -1 ||
          item.seller_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    }
    this.datauser = val === "" ? this.datausers : this.datauser;
  }

  setUserLoc(item) {
    _setStorage(STORAGE.userBu, item.bu);
    _setStorage(STORAGE.userLoc, item.seller_storeid);
    _setStorage(STORAGE.SOURCE_SYSTEM, item.source_system);
  }

  authSubject = new BehaviorSubject(false);
  async logout() {
    const getToken = _getStorage(STORAGE.TOKEN);

    const alert = await this.alertController.create({
      cssClass: "my-custom-class-alert",
      header: "Confirm Logout",
      // message: "Message <strong>text</strong>!!!",
      buttons: [
        {
          text: "CANCEL",
          role: "cancel",
          cssClass: "alertCancel",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
            // this.router.navigate(["/tax-invoice"]);
          },
        },
        {
          text: "OK",
          cssClass: "alertloginOk",
          handler: async (blah) => {
            const get_keyCardID = await _getStorage(STORAGE.DATA_KEY_CARDID);
            console.log("get_keyCardID=======: ", get_keyCardID);
            localStorage.clear();
            this.storage.clear();
            await _setStorage(
              STORAGE.DATA_KEY_CARDID,
              get_keyCardID === null ? [] : get_keyCardID
            );
            setTimeout(async () => {
              this.user = "";
              this.authSubject.next(false);
              this.app.resetdata();

              const newTab = window.open(
                "https://login.microsoftonline.com/common/oauth2/logout",
                "_blank",
                "popup"
              );
              if (newTab) {
                newTab.onunload = () => {
                  newTab.close();

                  window.location.replace(
                    this.apiservice.B2C_LOGOUT + getToken
                  );
                };
              }
            }, 1500);
          },
        },
      ],
    });

    await alert.present();
  }

  menu(a) {
    if (a === 4) {
      _setStorage("ActiveNoTaxID", a);
      _setStorage("nameNo", "tax");
      this.appService.setActiveNoCredit(a);
    } else {
      _setStorage("ActiveNoTaxID", a);
      _setStorage("nameNo", "tax");
      _setStorage("ActiveConfig", true);
      this.appService.setActiveNoCredit(a);
    }
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
